import PwaInstallPopupIOS from 'react-pwa-install-ios';
import sharee from "../img/share.png";

const MyComponent = () => {
    return (
        <PwaInstallPopupIOS
            delay={1}
            lang="fa">
            <div
                delay={0}
                style={{
                    direction:"rtl",
                    padding: '15px 30px',
                    backgroundColor: '#FFFFFF',
                    color: 'black',
                    textAlign: 'center',
                }}
            >
                برای نصب وب اپلیکیشن بر روی <img width={30}  height={30} src={sharee}/> که در پایین صفحه است , کلیک کنید و سپس {"Add to Home Screen"} را بزنید و برنامه را Add کنید
            </div>
        </PwaInstallPopupIOS>
    );
};

export default MyComponent